module.exports = __webpack_public_path__ + "static/placeholder-1ef3b60ce1f59a4f54c4bb2b9f247a53.svg";